import React from 'react';
import { Search, Calendar, Users } from 'lucide-react';
import { Dropdown } from '@/shared/components/atoms/Dropdown/Dropdown';

interface RecentCallsFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  days: number | undefined;
  setDays: (days: number | undefined) => void;
  selectedUserId: string | undefined;
  setSelectedUserId: (userId: string | undefined) => void;
  isOrgAdmin: boolean;
  teamMembers: any[];
}

export function RecentCallsFilters({
  searchQuery,
  setSearchQuery,
  days,
  setDays,
  selectedUserId,
  setSelectedUserId,
  isOrgAdmin,
  teamMembers
}: RecentCallsFiltersProps) {
  // Format options for custom Dropdown matching KB dropdowns
  const daysOptions = [
    { value: '', label: 'All Time' },
    { value: '7', label: 'Last 7 Days' },
    { value: '30', label: 'Last 30 Days' },
    { value: '90', label: 'Last 90 Days' }
  ];

  const teamOptions = [
    { value: '', label: 'All Team Members' },
    ...teamMembers.map((member) => ({
      value: member.id || member._id,
      label: member.name || member.email
    }))
  ];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      flexWrap: 'wrap'
    }}>
      {/* Search Input matching Knowledge Base Controls */}
      <div style={{ position: 'relative', flex: '1 1 300px' }}>
        <Search size={14} style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--admin-card-subtext)' }} />
        <input
          type="text"
          placeholder="Search by meeting title, rep, or platform..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            backgroundColor: 'var(--color-bg-elevated, rgba(255,255,255,0.03))',
            border: '1px solid var(--admin-card-border)',
            borderRadius: '0',
            padding: '9px 16px 9px 40px',
            color: 'var(--admin-card-text)',
            fontSize: '13px',
            fontFamily: "'Inter', sans-serif",
            outline: 'none',
            boxSizing: 'border-box'
          }}
        />
      </div>

      {/* Filters Matching Knowledge Base Controls */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        {/* Team Member Filter (Only shown to Org Admins) */}
        {isOrgAdmin && (
          <div style={{ minWidth: '170px' }}>
            <Dropdown
              value={selectedUserId || ''}
              onChange={(val) => setSelectedUserId(val === '' ? undefined : val)}
              options={teamOptions}
              placeholder="All Team Members"
              className="w-full kb-dropdown-tall"
            />
          </div>
        )}

        {/* Days Filter */}
        <div style={{ minWidth: '150px' }}>
          <Dropdown
            value={days === undefined ? '' : days.toString()}
            onChange={(val) => setDays(val === '' ? undefined : Number(val))}
            options={daysOptions}
            placeholder="All Time"
            className="w-full kb-dropdown-tall"
          />
        </div>
      </div>
    </div>
  );
}
